// import React, { useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import { Shield, Menu, X, LogOut, Zap } from "lucide-react";

// export default function Navbar() {
//   const { isAuthenticated, userProfile, logout } = useAuth();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);

//   async function handleLogout() {
//     await logout();
//     navigate("/");
//   }

//   const navLinks = [
//     { to: "/", label: "Home" },
//     { to: "/about", label: "About Us" },
//     { to: "/contact", label: "Contact" },
//   ];

//   return (
//     <nav className="fixed top-0 left-0 right-0 z-50 border-b border-surface-border bg-surface/80 backdrop-blur-xl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex items-center justify-between h-16 relative">
//           {/* Left — Logo */}
//           <Link to="/" className="flex items-center gap-2 group">
//             <div className="relative">
//               <Shield className="w-8 h-8 text-primary" />
//               <div className="absolute inset-0 w-8 h-8 text-primary opacity-50 blur-sm group-hover:opacity-100 transition-opacity">
//                 <Shield className="w-8 h-8" />
//               </div>
//             </div>
//             <span className="font-display text-2xl text-text-primary tracking-widest">
//               TRAX<span className="text-primary">ELON</span>
//             </span>
//           </Link>

//           {/* Center — Nav links */}
//           <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 items-center gap-8">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.to}
//                 to={link.to}
//                 className={`font-body text-sm tracking-wider uppercase transition-colors duration-200 ${location.pathname === link.to
//                     ? "text-primary"
//                     : "text-text-secondary hover:text-text-primary"
//                   }`}
//               >
//                 {link.label}
//               </Link>
//             ))}
//           </div>

//           {/* Right — User info + Logout */}
//           <div className="hidden md:flex items-center gap-4">
//             {isAuthenticated && userProfile ? (
//               <>
//                 <Link to="/dashboard">
//                   <div className="flex items-center gap-2 bg-surface-card border border-surface-border rounded-full px-4 py-1.5">
//                     <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
//                     <span className="font-body text-sm text-text-secondary">
//                       {userProfile?.displayName || "Officer"}
//                     </span>
//                     {userProfile?.credits !== undefined && (
//                       <span className="flex items-center gap-1 bg-primary/10 border border-primary/30 rounded-full px-2 py-0.5 text-xs text-primary font-mono">
//                         <Zap className="w-3 h-3" />
//                         {userProfile.credits}
//                       </span>
//                     )}
//                   </div>
//                 </Link>
//                 <button
//                   onClick={handleLogout}
//                   className="flex items-center gap-2 text-text-secondary hover:text-accent transition-colors text-sm"
//                 >
//                   <LogOut className="w-4 h-4" />
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <div className="flex items-center gap-3">
//                 <Link
//                   to="/login"
//                   className="font-body text-sm text-text-secondary hover:text-text-primary transition-colors"
//                 >
//                   Login
//                 </Link>
//                 <Link
//                   to="/signup"
//                   className="px-4 py-2 bg-primary text-surface font-body text-sm font-semibold rounded-lg hover:bg-primary-dark transition-all shadow-glow hover:shadow-glow-strong"
//                 >
//                   Sign Up
//                 </Link>
//               </div>
//             )}
//           </div>

//           {/* Mobile hamburger */}
//           <button
//             className="md:hidden text-text-secondary hover:text-text-primary"
//             onClick={() => setMobileOpen(!mobileOpen)}
//           >
//             {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//           </button>
//         </div>
//       </div>

//       {mobileOpen && (
//         <div className="md:hidden bg-surface-elevated border-b border-surface-border px-4 py-4 space-y-3">
//           {navLinks.map((link) => (
//             <Link
//               key={link.to}
//               to={link.to}
//               onClick={() => setMobileOpen(false)}
//               className="block font-body text-sm tracking-wider uppercase text-text-secondary hover:text-primary py-2"
//             >
//               {link.label}
//             </Link>
//           ))}
//           {isAuthenticated && userProfile ? (
//             <>
//               <Link to="/dashboard" onClick={() => setMobileOpen(false)} className="block text-sm text-primary py-2">
//                 Dashboard
//               </Link>
//               <button onClick={handleLogout} className="block text-sm text-accent py-2">
//                 Logout
//               </button>
//             </>
//           ) : (
//             <>
//               <Link to="/login" onClick={() => setMobileOpen(false)} className="block text-sm text-text-secondary py-2">Login</Link>
//               <Link to="/signup" onClick={() => setMobileOpen(false)} className="block text-sm text-primary py-2">Sign Up</Link>
//             </>
//           )}
//         </div>
//       )}
//     </nav>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Shield, Menu, X, LogOut, Zap, ChevronDown, User, Pencil, Check, AlertCircle, Eye, EyeOff } from "lucide-react";

export default function Navbar() {
  const { isAuthenticated, userProfile, currentUser, logout, updateUserProfile, verifyEmailChange } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  // Dropdown state
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [, setSaveSuccess] = useState(false);

  // OTP step state
  const [otpPending, setOtpPending] = useState(false);
  const [pendingNewEmail, setPendingNewEmail] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpSuccess, setOtpSuccess] = useState(false);

  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        closeDropdown();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function closeDropdown() {
    setDropdownOpen(false);
    setEditing(false);
    setSaveError("");
    setSaveSuccess(false);
    setCurrentPassword("");
    setOtpPending(false);
    setOtpInput("");
    setOtpError("");
    setOtpSuccess(false);
    setPendingNewEmail("");
  }

  function openEdit() {
    setEditName(userProfile?.displayName || "");
    setEditEmail(currentUser?.email || "");
    setCurrentPassword("");
    setSaveError("");
    setSaveSuccess(false);
    setOtpPending(false);
    setOtpInput("");
    setOtpError("");
    setEditing(true);
  }

  async function handleSave() {
    if (!editName.trim()) { setSaveError("Name cannot be empty."); return; }
    if (!editEmail.trim()) { setSaveError("Email cannot be empty."); return; }

    const emailChanged = editEmail.trim() !== currentUser.email;
    if (emailChanged && !currentPassword) {
      setSaveError("Enter your current password to change email.");
      return;
    }

    setSaving(true);
    setSaveError("");
    try {
      const result = await updateUserProfile(currentUser.uid, {
        displayName: editName.trim(),
        newEmail: editEmail.trim(),
        currentPassword: emailChanged ? currentPassword : null,
      });

      if (result?.otpSent) {
        // Switch to OTP entry step
        setPendingNewEmail(result.newEmail);
        setOtpPending(true);
        setEditing(false);
      } else {
        // Name-only change — done
        setSaveSuccess(true);
        setTimeout(() => {
          setEditing(false);
          setSaveSuccess(false);
          setCurrentPassword("");
        }, 2500);
      }
    } catch (err) {
      if (err.message?.includes("Incorrect password")) {
        setSaveError("Incorrect password. Please try again.");
      } else if (err.message?.includes("already in use") || err.code === "auth/email-already-in-use") {
        setSaveError("That email is already in use.");
      } else if (err.code === "auth/invalid-email") {
        setSaveError("Invalid email address.");
      } else {
        setSaveError(err.message || "Failed to save. Please try again.");
      }
    }
    setSaving(false);
  }

  async function handleOtpSubmit() {
    if (!otpInput.trim()) { setOtpError("Please enter the OTP."); return; }
    if (otpInput.trim().length !== 6) { setOtpError("OTP must be 6 digits."); return; }

    setOtpVerifying(true);
    setOtpError("");
    try {
      await verifyEmailChange(currentUser.uid, pendingNewEmail, otpInput.trim(), currentPassword);
      setOtpSuccess(true);
      setTimeout(() => {
        closeDropdown();
        navigate("/login", {
          state: { message: "Email updated! Please log in with your new email." }
        });
      }, 2000);
    } catch (err) {
      setOtpError(err.message || "Incorrect OTP. Please try again.");
    }
    setOtpVerifying(false);
  }

  async function handleLogout() {
    await logout();
    navigate("/");
  }

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/contact", label: "Contact" },
    { to: "/blog", label: "Blog" },
    { to: "/tools", label: "Tools" },
  ];

  const emailChanged = editEmail.trim() !== (currentUser?.email || "");

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-surface-border bg-surface/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 relative">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="relative">
              <Shield className="w-8 h-8 text-primary" />
              <div className="absolute inset-0 w-8 h-8 text-primary opacity-50 blur-sm group-hover:opacity-100 transition-opacity">
                <Shield className="w-8 h-8" />
              </div>
            </div>
            <span className="font-display text-2xl text-text-primary tracking-widest">
              TRAX<span className="text-primary">ELON</span>
            </span>
          </Link>

          {/* Center nav */}
          <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 items-center gap-8">
            {navLinks.map((link) => (
              <Link key={link.to} to={link.to}
                className={`font-body text-sm tracking-wider uppercase transition-colors duration-200 ${location.pathname === link.to ? "text-primary" : "text-text-secondary hover:text-text-primary"}`}>
                {link.label}
              </Link>
            ))}
          </div>

          {/* Right */}
          <div className="hidden md:flex items-center gap-4">
            {isAuthenticated && userProfile ? (
              <div className="relative" ref={dropdownRef}>

                {/* Pill button */}
                <button
                  onClick={() => { setDropdownOpen(o => !o); if (dropdownOpen) closeDropdown(); }}
                  className="flex items-center gap-2 bg-surface-card border border-surface-border rounded-full px-4 py-1.5 hover:border-primary/40 transition-colors"
                >
                  <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                  <span className="font-body text-sm text-text-secondary">
                    {userProfile?.displayName || "Officer"}
                  </span>
                  {userProfile?.credits !== undefined && (
                    <span className="flex items-center gap-1 bg-primary/10 border border-primary/30 rounded-full px-2 py-0.5 text-xs text-primary font-mono">
                      <Zap className="w-3 h-3" />
                      {userProfile.credits}
                    </span>
                  )}
                  <ChevronDown className={`w-3 h-3 text-text-muted transition-transform ${dropdownOpen ? "rotate-180" : ""}`} />
                </button>

                {/* Dropdown panel */}
                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-80 bg-surface-elevated border border-surface-border rounded-2xl shadow-card overflow-hidden z-50">

                    {/* Header */}
                    <div className="px-4 py-4 border-b border-surface-border">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                            <User className="w-4 h-4 text-primary" />
                          </div>
                          <div className="min-w-0">
                            <div className="font-body text-sm font-semibold text-text-primary truncate">
                              {userProfile?.displayName || "Officer"}
                            </div>
                            <div className="font-body text-xs text-text-muted truncate">
                              {currentUser?.email || ""}
                            </div>
                          </div>
                        </div>
                        {!editing && !otpPending && (
                          <button onClick={openEdit}
                            className="flex items-center gap-1 px-2.5 py-1.5 bg-primary/10 border border-primary/20 text-primary rounded-lg font-body text-xs hover:bg-primary/20 transition-colors flex-shrink-0">
                            <Pencil className="w-3 h-3" /> Edit
                          </button>
                        )}
                      </div>

                      {/* Badge ID (read-only) */}
                      {!editing && !otpPending && userProfile?.badgeId && (
                        <div className="mt-1">
                          <span className="font-body text-xs text-text-muted uppercase tracking-wider">Badge ID: </span>
                          <span className="font-mono text-xs text-text-primary">{userProfile.badgeId}</span>
                        </div>
                      )}

                      {/* ── EDIT FORM ── */}
                      {editing && (
                        <div className="space-y-3">
                          {/* Name */}
                          <div>
                            <label className="font-body text-xs text-text-muted uppercase tracking-wider">Name</label>
                            <input
                              type="text"
                              value={editName}
                              onChange={e => setEditName(e.target.value)}
                              className="mt-1 w-full bg-surface border border-surface-border rounded-lg px-3 py-2 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors"
                              placeholder="Your name"
                            />
                          </div>

                          {/* Email */}
                          <div>
                            <label className="font-body text-xs text-text-muted uppercase tracking-wider">Email</label>
                            <input
                              type="email"
                              value={editEmail}
                              onChange={e => setEditEmail(e.target.value)}
                              className="mt-1 w-full bg-surface border border-surface-border rounded-lg px-3 py-2 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors"
                              placeholder="Your email"
                            />
                          </div>

                          {/* Current password — only when email changes */}
                          {emailChanged && (
                            <div>
                              <label className="font-body text-xs text-text-muted uppercase tracking-wider">
                                Current Password <span className="text-primary">(required to change email)</span>
                              </label>
                              <div className="relative mt-1">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  value={currentPassword}
                                  onChange={e => setCurrentPassword(e.target.value)}
                                  className="w-full bg-surface border border-surface-border rounded-lg px-3 py-2 pr-9 font-body text-sm text-text-primary focus:outline-none focus:border-primary transition-colors"
                                  placeholder="Enter current password"
                                />
                                <button type="button" onClick={() => setShowPassword(s => !s)}
                                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-text-muted hover:text-primary">
                                  {showPassword ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
                                </button>
                              </div>
                            </div>
                          )}

                          {/* Info note */}
                          {emailChanged && !saveError && (
                            <p className="font-body text-xs text-text-muted">
                              📬 A 6-digit OTP will be sent to your new email to confirm the change.
                            </p>
                          )}

                          {/* Error */}
                          {saveError && (
                            <div className="flex items-center gap-1.5 text-red-400 font-body text-xs">
                              <AlertCircle className="w-3 h-3 flex-shrink-0" /> {saveError}
                            </div>
                          )}

                          {/* Buttons */}
                          <div className="flex gap-2">
                            <button onClick={handleSave} disabled={saving}
                              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-primary text-surface rounded-lg font-body text-xs font-bold hover:bg-primary-dark transition-colors disabled:opacity-60">
                              {saving ? "Sending OTP..." : "Save Changes"}
                            </button>
                            <button onClick={() => { setEditing(false); setSaveError(""); setCurrentPassword(""); }}
                              className="px-3 py-2 bg-surface border border-surface-border text-text-secondary rounded-lg font-body text-xs hover:border-primary/40 transition-colors">
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}

                      {/* ── OTP STEP ── */}
                      {otpPending && (
                        <div className="space-y-3 pt-1">
                          {/* Header */}
                          <div className="text-center pb-1">
                            <div className="w-10 h-10 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center mx-auto mb-2">
                              <span className="text-lg">📩</span>
                            </div>
                            <p className="font-body text-sm font-semibold text-text-primary">Check your new email</p>
                            <p className="font-body text-xs text-text-muted mt-0.5">
                              OTP sent to <span className="text-primary">{pendingNewEmail}</span>
                            </p>
                            <p className="font-body text-xs text-text-muted">Valid for 5 minutes.</p>
                          </div>

                          {/* OTP input */}
                          <div>
                            <label className="font-body text-xs text-text-muted uppercase tracking-wider">Enter 6-digit OTP</label>
                            <input
                              type="text"
                              inputMode="numeric"
                              maxLength={6}
                              value={otpInput}
                              onChange={e => { setOtpInput(e.target.value.replace(/\D/g, "")); setOtpError(""); }}
                              className="mt-1 w-full bg-surface border border-surface-border rounded-lg px-3 py-2 font-mono text-lg text-center text-text-primary tracking-[0.4em] focus:outline-none focus:border-primary transition-colors"
                              placeholder="000000"
                              autoFocus
                            />
                          </div>

                          {/* OTP error */}
                          {otpError && (
                            <div className="flex items-center gap-1.5 text-red-400 font-body text-xs">
                              <AlertCircle className="w-3 h-3 flex-shrink-0" /> {otpError}
                            </div>
                          )}

                          {/* OTP success */}
                          {otpSuccess && (
                            <div className="flex items-center gap-1.5 text-green-400 font-body text-xs">
                              <Check className="w-3 h-3 flex-shrink-0" /> Email updated successfully!
                            </div>
                          )}

                          {/* Buttons */}
                          <div className="flex gap-2">
                            <button
                              onClick={handleOtpSubmit}
                              disabled={otpVerifying || otpSuccess}
                              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 bg-primary text-surface rounded-lg font-body text-xs font-bold hover:bg-primary-dark transition-colors disabled:opacity-60"
                            >
                              {otpSuccess
                                ? <><Check className="w-3 h-3" /> Done!</>
                                : otpVerifying ? "Verifying..." : "Verify OTP"}
                            </button>
                            <button
                              onClick={() => { setOtpPending(false); setEditing(true); setOtpInput(""); setOtpError(""); }}
                              className="px-3 py-2 bg-surface border border-surface-border text-text-secondary rounded-lg font-body text-xs hover:border-primary/40 transition-colors"
                            >
                              Back
                            </button>
                          </div>

                          <p className="font-body text-xs text-text-muted text-center">
                            Wrong email?{" "}
                            <button
                              onClick={() => { setOtpPending(false); setEditing(true); setOtpInput(""); setOtpError(""); }}
                              className="text-primary hover:underline"
                            >
                              Go back to edit
                            </button>
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Actions */}
                    <div className="px-2 py-2 space-y-0.5">
                      <Link to="/dashboard" onClick={closeDropdown}
                        className="flex items-center gap-2 px-3 py-2 rounded-lg font-body text-sm text-text-secondary hover:bg-primary/10 hover:text-primary transition-colors">
                        Dashboard
                      </Link>
                      <button onClick={handleLogout}
                        className="w-full flex items-center gap-2 px-3 py-2 rounded-lg font-body text-sm text-text-secondary hover:bg-red-500/10 hover:text-red-400 transition-colors">
                        <LogOut className="w-4 h-4" /> Logout
                      </button>
                    </div>

                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link to="/login" className="font-body text-sm text-text-secondary hover:text-text-primary transition-colors">Login</Link>
                <Link to="/signup" className="px-4 py-2 bg-primary text-surface font-body text-sm font-semibold rounded-lg hover:bg-primary-dark transition-all shadow-glow hover:shadow-glow-strong">Sign Up</Link>
              </div>
            )}
          </div>

          {/* Mobile hamburger */}
          <button className="md:hidden text-text-secondary hover:text-text-primary" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-surface-elevated border-b border-surface-border px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link key={link.to} to={link.to} onClick={() => setMobileOpen(false)}
              className="block font-body text-sm tracking-wider uppercase text-text-secondary hover:text-primary py-2">
              {link.label}
            </Link>
          ))}
          {isAuthenticated && userProfile ? (
            <>
              <div className="font-body text-sm text-text-secondary py-1">
                {userProfile?.displayName || "Officer"} · {currentUser?.email}
              </div>
              <Link to="/dashboard" onClick={() => setMobileOpen(false)} className="block text-sm text-primary py-2">Dashboard</Link>
              <button onClick={handleLogout} className="block text-sm text-red-400 py-2">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMobileOpen(false)} className="block text-sm text-text-secondary py-2">Login</Link>
              <Link to="/signup" onClick={() => setMobileOpen(false)} className="block text-sm text-primary py-2">Sign Up</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}